import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { Button, Loader } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';

import { getAsoReport, getInvoices } from '../../../actions/invoices.js';
import AsoHistory from './AsoHistory.js';
import AsoReport from './AsoReport.js';
import { getPdf } from '../../../actions/master.js';

class AsoReports extends PureComponent {
    state = {
        selectedAsoReport: null
    };

    componentDidMount() {
        if (!this.props.history) {
            this.props.dispatch(getInvoices(this.props.currentAccountMeta.accountID)); // if we have no ASO History then we need to grab it (it's bundled in the GetInvoices call)
        }
    }

    _goToHistory = () => {
        this.setState({
            selectedAsoReport: null
        });
    };

    _selectReport = async (report) => {
        const selectedAsoReport = await this.props.dispatch(getAsoReport(report.asoReportID));

        this.setState({
            selectedAsoReport
        });
    };

    _downloadAsoReport = async (asoReportID, clientName, timeStamp, period, groupNum, accountID) => {
        const fileName = `Simply_Benefits_ASO_Report_${ dates.getLocalDisplay(this.props.date, 'MMMM_YYYY') }.pdf`;
        await this.props.dispatch(getPdf("AsoSummary", fileName, { asoReportID, clientName, timeStamp, groupNum, period, accountID }));
    };

    render() {
        const { whitelabel } = this.props;
        const styles = {
            titleBlock: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
                padding: '16px 0',
                marginTop: 10
            }
        };

        if (!this.props.history) {
            return <Loader/>;
        }

        return (
            <React.Fragment>
                <div style={ styles.titleBlock }>
                    {
                        this.state.selectedAsoReport &&
                            <>
                                <Button
                                    id="download-monthly-summary"
                                    color="white"
                                    noHover
                                    customStyle={{
                                        height: 50,
                                        width: 280,
                                        marginRight: "10px",
                                        textTransform: "capitalize",
                                        fontSize: 16
                                    }}
                                    onClick={() => this._downloadAsoReport(this.state.selectedAsoReport.asoReportID, this.props.currentAccountMeta.company, this.state.selectedAsoReport.timeStamp, this.state.selectedAsoReport.summary.period, this.props.currentAccountMeta.groupNum, this.props.currentAccountMeta.accountID)}
                                >
                                        Download Account Summary
                                </Button>

                                <Button
                                    id="view-history"
                                    color="primary"
                                    customStyle={{
                                        height: 50,
                                        width: 180,
                                        textTransform: "capitalize",
                                        fontSize: 16
                                    }}
                                    onClick={ this._goToHistory }
                                >
                                    View History
                                </Button>
                            </>
                    }
                </div>

                {
                    !this.state.selectedAsoReport ?
                        <AsoHistory
                            history={ this.props.history }
                            selectReport={ this._selectReport }
                        />
                        :
                        <AsoReport
                            asoReport={ this.state.selectedAsoReport }
                            whitelabel={ whitelabel }
                        />
                }
            </React.Fragment>
        );
    }
}

AsoReports.propTypes = {
    history: PropTypes.array,
    currentInvoice: PropTypes.object,
    selectedInvoice: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 * @param state
 * @returns {{selectedBill: null, admin: null, history: Array, loading: boolean, currentBill: null}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentAccountMeta: state.accounts.currentAccount.meta,
    history: state.invoices.asoReports?.history,
    admin: state.accounts.currentAccount.admins,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(AsoReports));